/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, InputAdornment, useTheme, Skeleton, TextField } from '@mui/material';
import FinanceTable from './FinanceTable';
import { SearchLg } from '../../../../assets';
import { EmptyTable } from '../../../../components/shared/EmptyTable';

const inputStyling = {
  width: '320px',
  '& .MuiInputBase-root': {
    height: '40px',
  },
};

const FinanceBox = (props: {
  data: any[];
  tableType: 'invoices' | 'creditNotes' | 'statements' | 'rebates' | 'loyalty';
  isLoading: boolean;
  page: number;
  totalPages: number;
  setPage: (page: number) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onDocumentDownload: (documentId: number) => Promise<void>;
}) => {
  const theme = useTheme();
  const { t } = useTranslation('finance');

  const handleClear = () => {
    props.setSearchTerm('');
    props.setPage(0);
  };

  const handleSearch = (value: string) => {
    props.setSearchTerm(value);
  };

  return (
    <>
      <Grid item
        mt={5}
        xs={12}>
        <Box paddingY={5}
          sx={{ display: 'flex', gap: 4, width: '100%' }}>
          <TextField
            onChange={(event) => handleSearch(event.target.value)}
            size='small'
            placeholder={t('search')}
            value={props.searchTerm}
            sx={{ ...inputStyling }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchLg />
                </InputAdornment>
              ),
            }} />
          <Button
            disabled={props.searchTerm === ''}
            variant="secondary"
            size="lg"
            onClick={handleClear}
            sx={{ width: '100px' }}
          >
            {t('clearFilters')}
          </Button>
        </Box>
        {props.isLoading
          ? <Skeleton sx={{ bgcolor: theme.palette.custom.gray[100] }}
            variant='rectangular'
            height={445.89} />
          : props.data.length === 0
            ?<EmptyTable
              text={t(props.tableType + 'Tab')}
              searchTerm={props.searchTerm}
              onClear={handleClear}
              onAdd={() => { }}
              showOnAdd={false}
              addItemText={t('newItem')}
              onAddIsCreating={false} />
            : <FinanceTable data={props.data}
              onDocumentDownload={props.onDocumentDownload}
              tableType={props.tableType}
              page={props.page}
              totalPages={props.totalPages}
              isLoading={props.isLoading}
              setPage={props.setPage} />}
      </Grid>
    </>
  );
};

export default FinanceBox;